# WHICH MANIFEST A STUDENT SESSION IS SERVED — one definition, read by the
# server and the client both. Card 6ac3ec94b9e010761617d2cf.
#
# Student.role (common/models/Student.coffee) mints the principal whose ACLs
# BUILD a student session's client API: Student.subscribed carries History and
# Student.playtime_stats, Student.unsubscribed carries neither. The /app router
# has to know which one it is holding before it sends the session to a screen,
# or it sends a child to the dashboard on a manifest that cannot render it.
#
# Measured in production 2026-10-05 (CrashLog 3ff3c45f): a teacher's trial
# ran out at midnight, the server read it — date only, as below — as
# unsubscribed, and the router, reading isUnsubscribedTeacher (true for ANY
# Trial teacher, live or lapsed), sent the student-locked session to the
# dashboard anyway: `Student.playtime_stats is not a function`, six times.
#
# The rule itself is unchanged by that card:
#   teacher / school / district  the account is provisioned with a trial
#     period, so the END DATE alone decides; the status is not read.
#   everybody else (a family)    status 'Subscribed' AND an end date in the
#     future — the same test Login.role and subscriptionRouting's
#     isActiveSubscription use.
#
# An account with no end date is unsubscribed in both arms. moment(undefined)
# is "now", which used to make that row's answer depend on which of two
# moment() calls ran first.
#
# CommonJS, like voicePhrases.coffee: the server requires it and webpack
# imports it into the client.
moment = require 'moment'

ORG_ACCOUNT_TYPES = ['teacher', 'school', 'district']

studentRole = (account, now = moment()) ->
  return 'unsubscribed' unless account?.subscription_end?
  live = moment(account.subscription_end).isAfter(now)
  if account.type in ORG_ACCOUNT_TYPES
    if live then 'subscribed' else 'unsubscribed'
  else
    if live and account.status == 'Subscribed' then 'subscribed' else 'unsubscribed'

module.exports = {studentRole, ORG_ACCOUNT_TYPES}
